(() => {
  const init = () => {
    const drawer = document.querySelector('#menu-drawer');
    if (!drawer || drawer.dataset.productFlyoutsReady) return;
    drawer.dataset.productFlyoutsReady = 'true';
    const details = drawer.closest('details');
    const desktop = matchMedia('(min-width: 990px) and (hover: hover)');
    let active, trigger, timer, restoring = false;
    const close = (restore = false) => {
      clearTimeout(timer);
      if (active?.matches(':popover-open')) active.hidePopover();
      trigger?.setAttribute('aria-expanded', 'false');
      const previous = trigger;
      active = trigger = null;
      if (restore) { restoring = true; previous?.focus(); restoring = false; }
    };
    const open = (panel, link) => {
      clearTimeout(timer);
      if (restoring || !desktop.matches || !details.open || !panel.showPopover) return;
      if (active !== panel) close();
      active = panel; trigger = link;
      const edge = drawer.getBoundingClientRect().right;
      panel.style.left = `${edge}px`;
      panel.style.width = `${Math.min(600, innerWidth - edge - 16)}px`;
      if (!panel.matches(':popover-open')) panel.showPopover();
      link.setAttribute('aria-expanded', 'true');
    };
    drawer.querySelectorAll('.menu-products').forEach(panel => {
      const link = [...drawer.querySelectorAll('.menu-drawer__group-links a')].find(a => new URL(a.href).pathname === panel.dataset.menuCollection);
      if (!link) return;
      link.setAttribute('aria-controls', panel.id);
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('pointerenter', () => open(panel, link));
      link.addEventListener('focus', () => open(panel, link));
      link.addEventListener('pointerleave', () => { timer = setTimeout(() => { if (!panel.matches(':hover') && !panel.contains(document.activeElement)) close(); }, 250); });
      link.addEventListener('keydown', event => {
        if (active === panel && (event.key === 'ArrowRight' || (event.key === 'Tab' && !event.shiftKey))) {
          event.preventDefault(); panel.querySelector('a').focus();
        }
      });
      panel.addEventListener('pointerenter', () => clearTimeout(timer));
      panel.addEventListener('pointerleave', () => { timer = setTimeout(() => { if (!link.matches(':hover') && !panel.contains(document.activeElement)) close(); }, 250); });
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && active) { event.preventDefault(); event.stopImmediatePropagation(); close(true); }
    }, true);
    details.addEventListener('toggle', () => { if (!details.open) close(); });
    document.addEventListener('focusin', event => { if (active && event.target !== trigger && !active.contains(event.target)) close(); });
    desktop.addEventListener('change', () => close());
    window.addEventListener('resize', () => close());
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
